import { CommonButton } from "@components/CommonButton";
import { IconLineClose } from "@kalodata/kds-design-icons";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export interface SettingHeaderProps {
  className?: string;
  onClick?: () => void;
}

export const SettingHeader = (props: SettingHeaderProps) => {
  const { className, onClick } = props;
  const { t } = useTranslation();
  return (
    <div className={twMerge("py-[10px] px-[16px] border-b border-kds-border", className)}>
      <div className="flex flex-row items-center gap-[8px]">
        <CommonButton className="w-[32px] px-0" icon={<IconLineClose />} onClick={onClick} />
        <div className="text-[16px] font-bold leading-[24px]">{t("Settings")}</div>
      </div>
    </div>
  );
};
